module.exports = require("react-google-maps/lib/components/places/StandaloneSearchBox");